import React from "react";
import { compose } from "recompose";
import { Form, Col, Row, Button, Icon, Empty, notification } from "antd";
import { withApollo } from "react-apollo";
import FileSaver from "file-saver";
import QRCode from "qrcode";
import moment from "moment";
import { withGlobal } from "../../../component-global";
import { BodyContainer } from "./styles";
import CustomInput from "./CustomInput";
import CustomResource from "./CustomResource";
// import * as route from "../../../routes/routes";

const coupImage =
  "https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2FIconsGameboy%2Fcoup.png?alt=media&token=81e9bfa9-9c13-41d8-8649-56ddfd3a95b0";
// const tonnyAPK = "https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/apks%2Fprod%2Fapp-release.apk?alt=media&token=2c73c773-9534-482d-9887-4cfa6e42857e";
// const tonnyAPK = "https://play.google.com/store/apps/details?id=com.chazki.affiliatetonny"
// const daliAPK = "https://play.google.com/store/apps/details?id=com.paquery.droid.latam"
// const supportUrl = "https://chazki792454279768380369.freshdesk.com/support/home"

const vehicleMoto = 234;
const BILLING_GROUP_NAME = "Datos de facturación";
const SIGNATURE_FIELD_NAME = "urlFileSignature";

const hasAssociatedAgency = agencyID => agencyID != null;

const shouldOmitFieldForAgency = (field, hasAgency) => {
  if (!hasAgency) {
    return false;
  }
  return (
    field.groupName === BILLING_GROUP_NAME ||
    field.name === SIGNATURE_FIELD_NAME
  );
};

class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicle: null,
      initSetVehicleType: false,
      isOwnerVehicle: false,
    };
  }

  groupByToArray = (array, key) => {
    const groups = array.reduce((acc, obj) => {
      const property = obj[key];
      acc[property] = acc[property] || [];
      acc[property].push(obj);
      return acc;
    }, {});
    const tempKeys = {};
    const keys = array.reduce((acc, obj) => {
      if (tempKeys[obj[key]] !== 1) {
        acc.push(obj[key]);
        tempKeys[obj[key]] = 1;
      }
      return acc;
    }, []);

    const arrayOfGroup = keys.map(obj => {
      return {
        groupName: obj,
        groupDescription: groups[obj][0].groupDescription,
        fields: groups[obj],
      };
    });

    return arrayOfGroup;
  };

  groupCheck = (values, arrayFiltered) => {
    const totalQuestions = arrayFiltered.length;

    if (!totalQuestions) return;
    const correctsArray = arrayFiltered.filter(
      obj => values[obj.name] === obj.value
    );

    const wrongAnswers = totalQuestions - correctsArray.length;
    const title =
      wrongAnswers === 0
        ? "¡Felicitaciones! Has respondido con éxito todas las preguntas"
        : ` ¡Uy! Solo fallaste en ${wrongAnswers} de ${totalQuestions} respuestas del test`;

    this.props.setCustomModalMessage(
      title,
      `Estas listo para unirte a nuestra flota, miles de rutas y clientes te esperan.`,
      coupImage
    );
  };

  formatToSave = values => {
    const omitForAgency = hasAssociatedAgency(this.props.affiliateAgencyID);
    const arrayFiltered = this.props.dataForm.fields.fields
      .filter(
        obj =>
          obj.type !== "video" &&
          obj.type !== "radio" &&
          obj.type !== "groupVideo"
      )
      .filter(field => !shouldOmitFieldForAgency(field, omitForAgency))
      .filter(field => {
        if (this.state.selectedVehicle === vehicleMoto) {
          return field.name === "categoryVehicleID";
        }
        if (!field.visibleForVehicle) {
          return true;
        }
        return field.visibleForVehicle.includes(this.state.selectedVehicle);
      });

    const arrayGroupRadioFiltered = this.props.dataForm.fields.fields.filter(
      obj => obj.type === "radio"
    );

    this.groupCheck(values, arrayGroupRadioFiltered);
    const jsonArrayData = [];
    const arrayFormatted = arrayFiltered
      .map(obj => {
        if (
          !obj.required &&
          (values[obj.name] === undefined ||
            values[obj.name] === null ||
            values[obj.name] === "")
        ) {
          return undefined;
        }
        let tempValue = values[obj.name];
        if (
          obj.type === "upload" &&
          tempValue &&
          Array.isArray(tempValue.fileList) &&
          tempValue.fileList.length
        ) {
          tempValue =
            tempValue.fileList[0] &&
            tempValue.fileList[0].response &&
            tempValue.fileList[0].response.url;
        }
        if (
          obj.type === "upload-optional" &&
          tempValue &&
          Array.isArray(tempValue.fileList) &&
          tempValue.fileList.length
        ) {
          const aux = [];
          tempValue.fileList.forEach(file => {
            if (file.url) {
              aux.push(file.url);
              return;
            }
            if (file.response && file.response.url) {
              aux.push(file.response.url);
            }
          });
          tempValue = JSON.stringify(aux);
        }
        if(obj.type === "calendar") {
          tempValue = tempValue.toISOString();
        }
        if (obj.jsonColum) {
          jsonArrayData.push({
            field: obj.name,
            table: obj.table,
            idDB: obj.idDB,
            dataType: obj.dataType,
            value: `${tempValue}`,
          });
          return undefined;
        }
        return {
          field: obj.name,
          table: obj.table,
          idDB: obj.idDB,
          dataType: obj.dataType,
          value: `${tempValue}`,
        };
      })
      .filter(e => e);

    if (jsonArrayData.length > 0) {
      const jsonData = jsonArrayData.reduce((acc, obj) => {
        if (!acc[obj.table]) {
          acc[obj.table] = {};
        }
        if (obj.dataType === "date") {
          acc[obj.table][obj.field] = /^\d+$/.test(obj.value)
            ? moment(new Date(Number(obj.value)))
                .format("YYYY-MM-DD")
                .toString()
            : moment(new Date(obj.value))
                .format("YYYY-MM-DD")
                .toString();
        } else {
          acc[obj.table][obj.field] = obj.value;
        }
        // acc[obj.table][obj.field] = obj.dataType === 'date'
        //   ? moment(new Date(obj.value)).format("YYYY-MM-DD").toString()
        //   : obj.value;
        return acc;
      }, {});

      Object.entries(jsonData).forEach(([key, value]) => {
        arrayFormatted.push({
          field: "extra",
          table: key,
          idDB: jsonArrayData.find(e => e.table === key).idDB,
          dataType: "jsonb",
          value: JSON.stringify(value),
        });
      });
    }
    return arrayFormatted;
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // Verifica la fecha de expiración de la licencia
        const dateToday = Date();
        if (
          values.driverLicenceExpirationDate &&
          moment(dateToday).format("YYYY-MM-DD") >
            moment(values.driverLicenceExpirationDate).format("YYYY-MM-DD")
        ) {
          notification.error({
            message: "No puede registrarse, la licencia está vencida",
          });
        } else {
          const result = this.formatToSave(values);
          this.props.onSaveChanges(result);
        }
      }
    });
  };

  downloadReviewQR = async () => {
    console.log("downloadReviewQR called", this.props.authUser);
    const affiliateID = this.props.authUser.profile.sub;
    const driverName = this.props.authUser.profile.given_name;
    const reviewUrl = `${process.env.REACT_APP_URL}qr/${affiliateID}`;

    if (!reviewUrl) return;

    try {
      const dataUrl = await QRCode.toDataURL(reviewUrl, {
        width: 300,
        margin: 2,
      });
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      FileSaver.saveAs(blob, `qr-calificacion-${driverName}.png`);
    } catch (error) {
      notification.error({
        message: "No se pudo generar el código QR",
      });
    }
  };

  onSelectChange = (value, name) => {
    if (name === "categoryVehicleID") {
      this.setState({
        selectedVehicle: parseInt(value, 10),
      });
    }
    if (name === "isOwnerVehicle") {
      this.setState({
        isOwnerVehicle: value === "No",
      });
    }
  };

  verifyVehicleType = (step, vehicle) => {
    console.log("args: ", step, vehicle);

    if (!step.length) return;

    const filteredResult = step
      .flatMap(group => group.fields) // Extraemos todos los campos en un solo nivel.
      .filter(field => field.value !== null) // Filtramos los campos que tienen valores no nulos.
      .reduce((acc, field) => {
        acc[field.name] = field.value; // Construimos un objeto con name como clave y value como valor.
        return acc;
      }, {});
    this.setState({
      selectedVehicle: filteredResult.categoryVehicleID,
      initSetVehicleType: true,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { selectedVehicle, initSetVehicleType, isOwnerVehicle } = this.state;
    let data =
      this.props.dataForm && this.props.dataForm.fields
        ? this.groupByToArray(this.props.dataForm.fields.fields, "groupName")
        : [];
    data = data.map(group => {
      return {
        ...group,
        fields: group.fields.map(field => {
          const country =
            this.props.userData && this.props.userData.Country
              ? this.props.userData.Country.name
              : null;
          const dependentFields = [
            "documentOfBelonging",
            "documentOfBelongingBack",
          ];
          const disabledFields = ["urlFileSignature"];
          if (dependentFields.includes(field.name) && country === "COLOMBIA") {
            field.required = isOwnerVehicle;
            return {
              ...field,
              disabled: !isOwnerVehicle,
            };
          }
          if (disabledFields.includes(field.name)) {
            field.disabled = true;
          }
          return field;
        }),
      };
    });
    if (!initSetVehicleType) this.verifyVehicleType(data, selectedVehicle);

    if (selectedVehicle === vehicleMoto) {
      data = data
        .map(group => {
          const filteredFields = group.fields.filter(
            field => field.name === "categoryVehicleID"
          );
          if (filteredFields.length > 0) {
            return { ...group, fields: filteredFields };
          }
          return null;
        })
        .filter(group => group !== null);
    }

    if (data && data.length && selectedVehicle !== vehicleMoto) {
      data = data.map(group => {
        const fieldsFilter = group.fields.filter(field => {
          if (!field.visibleForVehicle) {
            return true;
          }
          return field.visibleForVehicle.includes(selectedVehicle);
        });
        return {
          ...group,
          fields: fieldsFilter,
        };
      });
    }

    const omitForAgency = hasAssociatedAgency(this.props.affiliateAgencyID);
    if (omitForAgency && data && data.length) {
      data = data
        .map(group => ({
          ...group,
          fields: group.fields.filter(
            field => !shouldOmitFieldForAgency(field, omitForAgency)
          ),
        }))
        .filter(group => group.fields.length > 0);
    }

    const affiliateID = this.props.authUser.profile.sub;
    const reviewUrl = `${process.env.REACT_APP_URL}qr/${affiliateID}`;

    const displayGroups = () =>
      data.map(obj => {
        return (
          <div key={obj.groupName}>
            <h3 className="groupName">{obj.groupName}</h3>
            {obj.groupDescription && (
              <div className="groupDescription">{obj.groupDescription}</div>
            )}
            <Row gutter={20}>
              {(obj || []).fields.map((item, idx) => {
                if (
                  item.type !== "video" &&
                  item.type !== "groupVideo" &&
                  item.type !== "radio" &&
                  item.type !== "upload-optional"
                )
                  return (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      xl={12}
                      key={item.order}
                    >
                      <CustomInput
                        placeholder={item.label}
                        type={item.type}
                        getFieldDecorator={getFieldDecorator}
                        decorator={item.name}
                        value={item.value}
                        options={item.inputSelectValues}
                        required={item.required}
                        disabled={this.props.disabledInputs || item.disabled}
                        onSelectChange={this.onSelectChange}
                        name={item.name}
                      />
                    </Col>
                  );
                if (item.type === "upload-optional")
                  return (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      xl={12}
                      key={item.order}
                    >
                      <CustomInput
                        placeholder={item.label}
                        type={item.type}
                        getFieldDecorator={getFieldDecorator}
                        decorator={item.name}
                        value={item.value}
                        options={item.inputSelectValues}
                        required={item.required}
                        numRequired={item.numRequired}
                        disabled={this.props.disabledInputs}
                        onSelectChange={this.onSelectChange}
                        name={item.name}
                      />
                    </Col>
                  );
                return (
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={12}
                    xl={12}
                    key={`res${idx + 1}`}
                  >
                    <CustomResource
                      placeholder={item.label}
                      type={item.type}
                      getFieldDecorator={getFieldDecorator}
                      decorator={item.name}
                      value={item.value}
                      options={item.inputSelectValues}
                      resources={item.resources}
                      name={item.name}
                      onSaveChanges={this.props.onSaveChanges}
                      loadingOnSave={this.props.loadingOnSave}
                      required
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        );
      });

    return (
      <BodyContainer>
        <div className="WhiteContainer">
          {!this.props.currentStepID && !this.props.loadingRequest && (
            <Empty description="No se encontraron datos, probablemente haya un error con el usuario"></Empty>
          )}

          {this.props.completeTest ? (
            <Row>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <h2>
                  ¡Felicitaciones {this.props.authUser.profile.given_name}!
                </h2>
                <p>
                  Gracias por unirte a Chazki. Nos complace que quieras ser
                  parte de nuestra comunidad de conductores
                </p>
                <p>
                  Nuestro equipo de Flota te guiará a través del proceso de
                  afiliación y te capacitará en la app y nuestras operaciones.
                </p>
                <p>
                  Realizando entregas con nosotros, también podrás contar con
                  nuestro equipo de soporte para cualquier duda o inquietud.
                  Estarán pendientes de ti.
                </p>
                <p>
                  Estamos ansiosos por verte en acción. ¡Bienvenido a Chazki!
                </p>
                <p>
                  Atentamente,
                  <br />
                  Team Chazki.
                </p>
                {reviewUrl && (
                  <Button
                    size="large"
                    style={{
                      backgroundColor: "#307FE2",
                      color: "white",
                      borderColor: "#307FE2",
                      marginTop: 24,
                    }}
                    onClick={this.downloadReviewQR}
                  >
                    Mi QR de reseñas de Google <Icon type="download" />
                  </Button>
                )}
                {/** Botones removidos en ticket CRT-300
                <Button
                  size="large"
                  style={{
                    backgroundColor: "#307FE2",
                    color: "white",
                    borderColor: "#307FE2",
                    margin: 24,
                  }}
                  onClick={() => {
                     window.open(
                      tonnyAPK
                    );
                  }}
                >
                  Descarga la App de Chazki <Icon type="download" />
                </Button>
                <Button
                  size="large"
                  style={{
                    backgroundColor: "#0CB8B1",
                    color: "white",
                    borderColor: "#0CB8B1",
                    margin: 24,
                  }}
                  onClick={() => {
                    window.open(
                      daliAPK
                    );
                  }}
                >
                  Descarga la App de Dali <Icon type="download" />
                </Button>
                */}
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
            </Row>
          ) : (
            <Row>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <Form>
                  <h2 className="titleStep">
                    {this.props.dataForm && this.props.dataForm.name}
                  </h2>
                  {this.props.dataForm &&
                    this.props.dataForm.description &&
                    this.props.dataForm.description
                      .replace(
                        /Nombre_usuario/gi,
                        this.props.userData
                          ? `${this.props.userData.names} ${this.props.userData.lastname}`
                          : null
                      )
                      .split("<br>")
                      .map((str, index) => <p key={index}>{str}</p>)}
                  {displayGroups()}
                  {this.props.dataForm &&
                    this.props.dataForm.proccessBD &&
                    this.props.dataForm.fields.fields[0].type !==
                      "groupVideo" && (
                      <div className="sendButton">
                        <Button
                          style={{
                            color: "white",
                            backgroundColor: "#307FE2",
                            height: 48,
                          }}
                          type="submit"
                          onClick={this.handleSubmit}
                          size="large"
                          loading={this.props.loadingOnSave}
                          disabled={this.props.disabledInputs}
                        >
                          Siguiente
                          <Icon type="right" />
                        </Button>
                      </div>
                    )}
                </Form>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
            </Row>
          )}
        </div>
      </BodyContainer>
    );
  }
}

const WraperBody = withGlobal(Body);
const BodyForm = Form.create()(WraperBody);

export default compose(withApollo)(BodyForm);
